export default __webpack_public_path__ + "static/media/stats.bcf1d7df.svg";